import React, { useEffect, useState } from 'react';
import LayoutHeader from './components/LayoutHeader';
import HomeHero from './components/HomeHero';
import ServicesSection from './components/ServicesSection';
import ExperienceSection from './components/ExperienceSection';
import AboutMeSection from './components/AboutMeSection';
import TestimonialsSlider from './components/TestimonialsSlider';
import ContactForm from './components/ContactForm';
import LayoutFooter from './components/LayoutFooter';

// ⬇️ importa el panel de administración
import AdminTestimonials from './components/AdminTestimonials';

function App() {
  const [currentPage, setCurrentPage] = useState('inicio');

  // Soporta /admin si el usuario entra directo o recarga
  useEffect(() => {
    if (window.location.pathname === '/admin') {
      setCurrentPage('admin');
    } else {
      setCurrentPage('inicio');
    }

    // Maneja el botón "atrás" del navegador
    const onPop = () => {
      setCurrentPage(window.location.pathname === '/admin' ? 'admin' : 'inicio');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const handleNavigate = (page) => {
    setCurrentPage(page);

    // Actualiza la URL (sin React Router)
    if (page === 'admin') {
      window.history.pushState({}, '', '/admin');
    } else {
      window.history.pushState({}, '', '/');
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="font-sans antialiased text-gray-900">
      {/* Si quieres ocultar el header en el panel admin, condicionaliza aquí */}
      <LayoutHeader onNavigate={handleNavigate} currentPage={currentPage} />

      <main>
        {currentPage === 'inicio' && (
          <>
            <HomeHero onNavigate={handleNavigate} />
            <ServicesSection />
            <ExperienceSection />
            <AboutMeSection />
            <TestimonialsSlider />
            <ContactForm />
          </>
        )}

        {currentPage === 'servicios' && <ServicesSection />}
        {currentPage === 'experiencia' && <ExperienceSection />}
        {currentPage === 'sobreMi' && <AboutMeSection />}
        {currentPage === 'testimonios' && <TestimonialsSlider />}
        {currentPage === 'contacto' && <ContactForm />}

        {/* Página de administración */}
        {currentPage === 'admin' && <AdminTestimonials />}
      </main>

      <LayoutFooter onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
